import { apiClient } from "@/shared/api/client"

export interface BotSummaryStats {
	sessions: {
		total: number
		blocked: number
		activeDay: number
		activeWeek: number
		activeMonth: number
		newWeek: number
	}
	/** Люди, перенесённые без Telegram ID и ещё не написавшие боту. */
	pending: { total: number; notFound: number }
	newByDay: { day: string; count: number }[]
}

export interface FlowStats {
	flows: { flowId: string; started: number; finished: number }[]
	nodes: { nodeId: string; passed: number; stuck: number }[]
	/** Сколько человек нажали кнопку, вместе с историей из Botmaker. */
	buttons: { nodeId: string; buttonId: string; clicks: number }[]
}

export interface TagStats {
	total: number
	tags: { tagId: string; count: number }[]
}

export interface EntryLinkStat {
	code: string
	/** Сколько разных людей пришло по метке. */
	count: number
	/** Из них дошли до конца сценария, ждут ответа, заблокировали бота. */
	finished: number
	waiting: number
	blocked: number
	/** Последний переход по метке, ISO. */
	lastAt: string
}

export interface EntryLinkStats {
	links: EntryLinkStat[]
}

export const statsKeys = {
	summary: (botId: string) => ["bot-builder", "stats", botId, "summary"] as const,
	flows: (botId: string, entryLink = "") =>
		["bot-builder", "stats", botId, "flows", entryLink] as const,
	tags: (botId: string) => ["bot-builder", "stats", botId, "tags"] as const,
	entryLinks: (botId: string) => ["bot-builder", "stats", botId, "entry-links"] as const,
}

const statsPath = (botId: string, path: string) => `/admin/custom-bots/${botId}/stats/${path}`

export const getSummaryStats = async (botId: string) =>
	(await apiClient.get<BotSummaryStats>(statsPath(botId, "summary"))).data

/** С кодом метки считает только людей, пришедших по ней. */
export const getFlowStats = async (botId: string, entryLink?: string) =>
	(
		await apiClient.get<FlowStats>(statsPath(botId, "flows"), {
			params: entryLink ? { entryLink } : undefined,
		})
	).data

export const getTagStats = async (botId: string) =>
	(await apiClient.get<TagStats>(statsPath(botId, "tags"))).data

export const getEntryLinkStats = async (botId: string) =>
	(await apiClient.get<EntryLinkStats>(statsPath(botId, "entry-links"))).data

/** Кому можно написать: по каждому боту и по всем аккаунтам в системе. */
export interface BotReach {
	bots: {
		botId: string
		name: string
		username: string
		enabled: boolean
		status: string
		/** Пишут боту и не заблокировали его. */
		reachable: number
		blocked: number
		/** Перенесены без Telegram ID: найдём перед рассылкой. */
		awaitingId: number
		notFound: number
	}[]
	system: {
		people: number
		reachablePeople: number
		unreachablePeople: number
		clubUsers: number
		clubWithTelegram: number
		clubWithoutTelegram: number
		clubReachable: number
		clubNotInBots: number
	}
}

export const botReachKey = ["bot-builder", "reach"] as const

export const getBotReach = async () => {
	const { data } = await apiClient.get<BotReach>("/admin/bot-reach")
	return data
}
